import { useRef, useState } from 'react';
import { ALPHABET } from '../constants/alphabetLetters';
import { PartnerDetail } from '../types/types';
import KeyboardButton from './KeyboardButton';
import { useFetchPartners } from '../hooks/useFetchPartners';
import { sortPartnersByLetter } from '../utils/partners';
import PartnerItem from './PartnerItem';
import '../scss/filter-list-checkbox.scss';
import '../scss/filter-list-container.scss';

interface Props {
  selectedPartners: string;
  handlePartnerClick: (partner: PartnerDetail) => void;
}

const FilterPartnerContent: React.FC<Props> = ({ selectedPartners, handlePartnerClick }) => {
  const { data: partners } = useFetchPartners();
  const sortedPartners = sortPartnersByLetter(partners || []);
  const [letterPressed, setLetterPressed] = useState<string>('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleLetterClick = (letter: string) => {
    if (dropdownRef.current) {
      setLetterPressed(letter);
      const keyElement = dropdownRef.current.querySelector(`[data-key="${letter}"]`);
      if (keyElement) {
        keyElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="filter-list__item pt-2">
      <div className="filter-list__name font-yettel-bold">Partneri</div>

      <section>
        {ALPHABET.map((letter, index) => (
          <KeyboardButton
            key={index}
            isPressed={letterPressed === letter}
            letter={letter}
            handleClick={() => handleLetterClick(letter)}
          />
        ))}
      </section>

      <section className="filter-list__fixed-height filter-list__partners mt-3" ref={dropdownRef}>
        {partners &&
          sortedPartners.letters.map(letter => (
            <PartnerLetter key={letter} letter={letter}>
              {sortedPartners.items[letter]?.map(partner => (
                <PartnerItem
                  key={partner.id}
                  partner={partner}
                  isPartnerSelected={selectedPartners.includes(partner.id)}
                  handlePartnerClick={handlePartnerClick}
                  index={partner.index as number}
                />
              ))}
            </PartnerLetter>
          ))}
      </section>
    </div>
  );
};

interface PartnerLetterProps {
  letter: string;
  children: React.ReactNode;
}

const PartnerLetter: React.FC<PartnerLetterProps> = ({ children, letter }) => {
  return (
    <div className="filter-list__checkbox-item" key={letter} data-key={letter}>
      <div className="filter-list__checkbox-item__key-name">{letter}</div>
      {children}
    </div>
  );
};

export default FilterPartnerContent;
